import TableCell from '@material-ui/core/TableCell';
import styled from 'styled-components';

export const StyledTableCell = styled(TableCell)`
    border-left: 1px solid rgba(224, 224, 224, 1);
`;

export const ActionTableCell = styled(StyledTableCell)`
    text-align: right;
    padding: 6px 16px;
`;

export const PaddingTableCell = styled(StyledTableCell)`
    padding: 0;
    background-color: #e4e4e4;
`;